import { ErrorHandler } from '@angular/core';
import Bugsnag from '@bugsnag/js';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';

export function errorHandlerFactory() {
  return new BugsnagErrorHandler();
}

// Custom error handler to filter out ResizeObserver warning
export class CustomErrorHandler implements ErrorHandler {
  constructor() {
    // Catching errors globally using window.onerror
    window.onerror = (message, source, lineno, colno, error) => {
      if (message.toString().includes('ResizeObserver loop completed with undelivered notifications')) {
        // Prevent sending the specific warning to Bugsnag
        return true; // Return true to prevent further handling (Bugsnag won't log it)
      }
      // Otherwise, report to Bugsnag
      if (error) {
        Bugsnag.notify(error);
      }
      return false; // Return false to let the browser handle the error as usual
    };
  }

  handleError(error: any): void {
    // Fallback error handling for other errors
    Bugsnag.notify(error);
  }
}
